import { createFileRoute } from '@tanstack/react-router'

import { presetRange } from '@/lib/date-range'
import { performanceQueryOptions } from '@/features/reports-analytics/queries'
import { ReportsPage } from '@/features/reports-analytics/components/ReportsPage'

export const Route = createFileRoute('/_authed/reports')({
  loader: ({ context }) => {
    // Warm the default view (last 7 days) so the chart is ready on load.
    const today = new Date()
    const range = presetRange('last7', today)!
    return context.queryClient
      .ensureQueryData(performanceQueryOptions(range, today))
      .catch(() => undefined)
  },
  component: ReportsPage,
})
